module.exports = __webpack_public_path__ + "img/login.7a6aefb9.png";